import React from 'react';
import Button from './Button';
import { Link } from 'react-router-dom';

const CallToAction: React.FC = () => {
  return (
    <section className="relative py-20 bg-black">
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-30"
        style={{ 
          backgroundImage: "url('https://images.pexels.com/photos/28080/pexels-photo.jpg?auto=compress&cs=tinysrgb&w=1600')"
        }}
      />
      
      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/60 to-black/80"></div>
      
      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 text-center">
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-6">
          READY TO BUILD YOUR BEST BODY?
        </h2>
        <p className="text-xl text-gray-300 max-w-2xl mx-auto mb-10">
          Join the program that's transformed countless aussie dreams. <br></br>
          Your transformation starts today.
        </p>
        <div className="relative inline-block">
          <div className="absolute -top-2 left-1/2 transform -translate-x-1/2 w-16 h-1 bg-red-600"></div>
          <Link to="/contact">
            <Button>START YOUR JOURNEY NOW</Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;